export const applyTransientProps = <T>(props: T, styleFn: (...args: any[]) => any): Record<string, any> => {
  const styleProps: Record<string, any> = {};

  /**
   * This is the equivalent of doing this manually
   * {
   *  myProp1: props.$myProp1,
   *  myProp2: props.$myProp2,
   *  myProp3: props.$myProp2,
   * }
   */
  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith('$')) {
      const originalKey = key.slice(1); // Remove the '$' prefix
      styleProps[originalKey] = value;
    }
  }

  return styleFn(styleProps);
};

/**
 * PrependDollar copies another type and prepends every key with a dollar sign.
 * This is used so that styled-components don't pass the style props to the dom by using transient props
 * See: https://styled-components.com/docs/basics#passed-props
 * See: https://styled-components.com/docs/api#transient-props
 * Explanation of the problem: https://stackoverflow.com/questions/73766100/why-is-styled-components-adding-my-attributes-to-the-dom
 */
export type PrependDollar<T> = {
  [K in keyof T as `$${K & string}`]: T[K];
};
